import * as React from 'react';
import FormControl from '@mui/material/FormControl';
import axios from 'axios';
import { MessageBarType } from '@fluentui/react';
import { DatePicker, defaultDatePickerStrings, Stack, Dropdown, TextField } from '@fluentui/react';
import { FormControlLabel } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import * as APP_CONSTANTS from '../../shared/Constants';
import { BpCheckedIcon, BpIcon } from '../../components/common/CheckboxWrapper';
import { fetchFieldsData } from '../../utility/fetchData';
import { fetchIssueStatus, fetchIssueSeverity, fetchIssueType } from '../../utility/grid/helper/StatusFetch';
import BorderIcon from '../../components/BorderIcon';
import AttachmentContainer from '../../components/common/AttachmentContainer';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import { CmicContext } from '../../context/CmicContext';
import { ActionContext } from '../../context/ActionContext';
import { COLORS } from '../../utility/tasks/colors';
import { THEME_ID, customStyles, invalidCustomStyles, handleTextTheme, baseFontFamilyStyle } from '../../shared/styles';
import { downloadAttachmentLocally } from './../tasks/SaveAttachment';
import { v4 as uuidv4 } from 'uuid';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { components } from 'react-select';
import { Divider } from '@mui/material';
import CustomizedMenus from './Menu';
import { MdCloudUpload } from 'react-icons/md';
import { createOpenURL, hashFileName, isBGClrDark } from '../../utility/UtilityFunctions';
import { handleTHEMECLR } from '../../components/BorderImage';
import {
	handleLoginUserViaAuth2,
	formatDate,
	isInternetAvailable,
	checkExtraSlashAPIURL,
	removeEmojis,
} from '../../shared/UtilityFunctions';
import { segmentDefaultTrackCall } from '../../utility/segment/segmentUtility';
import './CreateActions.scss';

const handleHeader = type => {
	switch (type) {
		case APP_CONSTANTS.ACTION_TYPE.NEW:
			return `Create`;
		case APP_CONSTANTS.ACTION_TYPE.EXISTING:
			return `Add To Existing`;
		case APP_CONSTANTS.ACTION_TYPE.ATTACHMENT:
			return `Attach To`;
		default:
			break;
	}
};

const INIT_CONCATS_CONFIG = {
	items: [],
	hasMore: true,
	offset: 0,
	search: '',
};

const CreateActions = ({ selectedNodeType, attachedData = [] }) => {
	const { useContext, useEffect, useState, useRef } = React;

	const { userInfo, currentOfficeTheme, selectedProject, setShowToast } = useContext(CmicContext);
	const {
		actionTypeData,
		setFieldsToCreateNewPMItems,
		fieldsToCreateNewPMItems,
		autoFillMailToggle,
		setAutoFillMailToggle,
		attachmentData,
		selectedEmailContent,
		isLoading,
		setIsLoading,
		setSelectedEmailContent,
		setAttachmentData,
		setActionTypeData,
		handleSwitchToBrowse,
	} = useContext(ActionContext);

	const [type, setType] = useState([]);
	const [status, setStatus] = useState([]);
	const [severity, setSeverity] = useState([]);
	const [responsibility, setResponsibility] = useState(INIT_CONCATS_CONFIG);
	const [header, setHeader] = useState('');
	const [isSubmitted, setIsSubmitted] = useState(false);
	const [isFromDropFocused, setIsFromDropFocused] = useState(false);
	const [isToDropFocused, setIsToDropFocused] = useState(false);
	const [isDefaultContact, setIsDefaultContact] = useState(false);
	const timer = useRef(null);

	const navigate = useHistory();

	const autoResizeTextarea = (e) => {
		const el = e.target;
		el.style.height = 'auto';
		el.style.height = `${el.scrollHeight}px`;

		const atEnd = el.selectionStart === el.value.length && el.selectionEnd === el.value.length;
		if (atEnd) {
			el.scrollTop = el.scrollHeight;
			const formContainer = el.closest('.createNewAction');
			if (formContainer) {
				formContainer.scrollTop = formContainer.scrollHeight;
			}
		}
	};

	const textareaRefCallback = (el) => {
		if (el) {
			el.style.height = 'auto';
			el.style.height = `${el.scrollHeight}px`;
		}
	};

	// Styles

	const headerTextStyle = {
		fontWeight: '6000',
		fontFamily: baseFontFamilyStyle,
		color:
			currentOfficeTheme.themeId === THEME_ID.BLACK || currentOfficeTheme.themeId === THEME_ID.DARK_GREY
				? currentOfficeTheme.bodyForegroundColor
				: '#5E6367',
		margin: '0.5rem 3px',
	};

	const loaderStyles = {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		width: '100%',
		height: '100%',
	};

	const textInputStyles = props => {
		return {
			fieldGroup: {
				width: '100%',
				minHeight: '38px',
				background: currentOfficeTheme.bodyBackgroundColor,
				color: currentOfficeTheme.bodyForegroundColor,
				':hover': {
					border: `0.8px solid ${currentOfficeTheme.bodyForegroundColor}`,
				},
				border: '1px solid rgba(174, 180, 189, 1)',
				borderRadius: 0,
			},
			field: {
				color: currentOfficeTheme.bodyForegroundColor,
				fontFamily: baseFontFamilyStyle,
				border: 'none',
				':disabled': {
					background: 'none',
					opacity: 0.8,
				},
			},

			subComponentStyles: {
				label: getLabelStyle,
			},
		};
	};

	const getLabelStyle = props => {
		return {
			root: {
				color: currentOfficeTheme.bodyForegroundColor,
				fontFamily: baseFontFamilyStyle,
			},
		};
	};

	const stackTokens = { childrenGap: 10 };

	const parentStackStyles = {
		root: {
			height: '100%',
			background: 'transparent',
			alignContent: 'center',
			overflowY: 'scroll',
			marginBottom: '1%',
		},
	};

	const headerStyles = {
		fontFamily: baseFontFamilyStyle,
		fontSize: '18px',
		fontWeight: 'normal',
		marginTop: '5px',
		marginLeft: '15px',
		color: currentOfficeTheme.bodyForegroundColor,
	};

	const dropdownStyles = {
		title: {
			backgroundColor: currentOfficeTheme.bodyBackgroundColor,
			color: currentOfficeTheme.bodyForegroundColor,
		},
		dropdown: { backgroundColor: currentOfficeTheme.bodyBackgroundColor },
		dropdownItemSelected: {
			backgroundColor: currentOfficeTheme.bodyBackgroundColor,
			color: currentOfficeTheme.bodyForegroundColor,
		},
		dropdownDivider: { backgroundColor: currentOfficeTheme.bodyBackgroundColor },
		label: { color: currentOfficeTheme.bodyForegroundColor },
	};

	const datePickerStyles = {
		callout: {
			selectors: {
				'& button': {
					backgroundColor: currentOfficeTheme.bodyBackgroundColor,
					color: currentOfficeTheme.bodyForegroundColor,
				},
			},
		},
		root: {},

		textField: {
			'& .ms-Label': {
				color: currentOfficeTheme.bodyForegroundColor,
			},
			'& .ms-TextField-fieldGroup': {
				borderColor:
					currentOfficeTheme.themeId === THEME_ID.BLACK || currentOfficeTheme.themeId === THEME_ID.DARK_GREY
						? 'rgba(174, 180, 189, 1)'
						: 'rgb(128,128,128, 0.4)',
				backgroundColor: currentOfficeTheme.bodyBackgroundColor,
				borderRadius: 0,
				color: currentOfficeTheme.bodyForegroundColor,
				':hover': {
					borderColor: currentOfficeTheme.bodyForegroundColor,
				},
				':after': {
					borderColor: 'transparent',
				},
			},
			'& .ms-TextField-field': {
				color: currentOfficeTheme.bodyForegroundColor,
			},
			'& input[readonly]': {
				color: currentOfficeTheme.bodyForegroundColor,
				backgroundColor: currentOfficeTheme.bodyBackgroundColor,
			},
		},
		icon: {
			color: currentOfficeTheme.bodyForegroundColor,
		},
	};

	const datePickerCalendarStyles = {
		styles: {
			root: {
				backgroundColor: currentOfficeTheme.bodyBackgroundColor,
				color: currentOfficeTheme.bodyForegroundColor,
			},
		},
		calendarDayProps: {
			styles: {
				dayCell: {
					color: currentOfficeTheme.bodyForegroundColor,
					':focus': {
						backgroundColor: currentOfficeTheme.bodyForegroundColor,
						color: currentOfficeTheme.bodyBackgroundColor,
					},
					':hover': {
						backgroundColor: currentOfficeTheme.bodyForegroundColor,
						color: currentOfficeTheme.bodyBackgroundColor,
					},
				},
			},
		},
	};

	useEffect(() => {
		const heading = handleHeader(actionTypeData.type);
		setHeader(`${heading} ${actionTypeData.label}`);
		setFieldsToCreateNewPMItems({
			project: '',
			From: '',
			responsibility: '',
			subject: '',
			status: '',
			date: addBusinessDaysToDate(),
			question: '',
			HTMLQuestion: '',
			answer: '',
			title: '',
			description: '',
			HTMLDescription: '',
			type: '',
			severity: '',
		});
		setIsLoading(false);
		Office.context.mailbox.item.body.getAsync(Office.CoercionType.Text, function (asyncResult) {
			if (asyncResult.status !== Office.AsyncResultStatus.Succeeded) {
				// TODO: Handle error
			} else {
				const subject = Office.context.mailbox.item.subject.substring(0, 200);
				setFieldsToCreateNewPMItems(prev => {
					return {
						...prev,
						HTMLQuestion: asyncResult.value,
						question: asyncResult.value,
						subject: subject,
						HTMLDescription: asyncResult.value,
						description: asyncResult.value,
						title: subject,
					};
				});
			}
		});

		setAutoFillMailToggle(true);
	}, [actionTypeData]);

	useEffect(async () => {
		try {
			let params = {
				projOraseq: selectedProject.value,
				firstName: userInfo.info.firstName,
				offset: 0,
			};

			const fieldsFromContactData = await fetchFieldsData(
				APP_CONSTANTS.CMIC_FIELD_REST__NAMES.contacts,
				userInfo,
				params,
			);

			(fieldsFromContactData.items || []).map(value => {
				const arrayData = {
					key: value.PmpcContactOraseq,
					label: `${value.PmpcFirstName} ${value.PmpcLastName}`,
					data: value,
				};

				if (value.PmpcContactCode === userInfo.info.contactCode) {
					setFieldsToCreateNewPMItems(prev => {
						return {
							...prev,
							From: arrayData,
						};
					});
				}
			});

			if (selectedNodeType === APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI) {
				params = {
					projOraseq: selectedProject.value,
					firstName: selectedProject.PmpDfltRfiContactCode,
					offset: 0,
				};

				const fieldsResponsibilityContactData = await fetchFieldsData(
					APP_CONSTANTS.CMIC_FIELD_REST__NAMES.contacts,
					userInfo,
					params,
				);

				let respData = {
					key: '',
					label: '',
					data: '',
				};

				(fieldsResponsibilityContactData.items || []).forEach(value => {
					if (value.PmpcContactCode === selectedProject.PmpDfltRfiContactCode) {
						respData = {
							key: value.PmpcContactOraseq,
							label: `${value.PmpcFirstName} ${value.PmpcLastName}`,
							data: value,
						};
					}
				});

				//Setting responsibility
				if (respData.data) {
					setFieldsToCreateNewPMItems(prev => {
						return {
							...prev,
							responsibility: respData,
						};
					});
					// Showing indication that we got default concat code for 'To' field
					setIsDefaultContact(true);
				}
			}

			if (selectedNodeType === APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI) {
				const fieldsStatus = await fetchFieldsData(
					APP_CONSTANTS.CMIC_FIELD_REST__NAMES.rfistatus,
					userInfo,
					params,
				);
				let arrStatus = fieldsStatus.map(value => {
					return {
						key: value.PmrfisStatusClassCode,
						label: value.PmrfisStatusName,
						data: value,
					};
				});
				setStatus(arrStatus);
			}

			if (selectedNodeType === APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE) {
				// set Severity for Issue
				const severityData = await fetchIssueSeverity(userInfo);
				let arrSeverity = severityData.map(value => {
					return {
						key: value.DmipPriorityCode,
						label: value.DmipDesc,
						data: value,
					};
				});
				setSeverity(arrSeverity);

				// set Issue Type for Issue
				const typeData = await fetchIssueType(userInfo);
				let arrType = typeData.map(value => {
					return {
						key: value.DmitTypeCode,
						label: value.DmitDesc,
						data: value,
					};
				});
				setType(arrType);

				// set Issue status for Issue
				const statusData = await fetchIssueStatus(userInfo);
				let arrStatus = statusData.map(value => {
					return {
						key: value.DmisStatusCode,
						label: value.DmisDesc,
						data: value,
					};
				});
				setStatus(arrStatus);
			}
		} catch (error) {
			console.log('ERROR useEffect', error);
		}
	}, []);

	const addBusinessDaysToDate = () => {
		let date = new Date();
		let days;
		let workingDayFlag;
		if (selectedNodeType === APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI) {
			days = selectedProject.PmpDefaultRfiPeriod;
			workingDayFlag = selectedProject.PmpCalcRfiDtOnWrkdys;
		} else if (selectedNodeType === APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE) {
			days = selectedProject.PmpDfltIssueRevPeriod;
			workingDayFlag = selectedProject.PmpCalcIssueDtOnWrkdys;
		}
		// TODO for COMMUNICATION
		if (workingDayFlag) {
			let day = date.getDay();
			date = new Date(date.getTime());
			date.setDate(
				date.getDate() + days + (day === 6 ? 2 : +!day) + Math.floor((days - 1 + (day % 6 || 1)) / 5) * 2,
			);
			return date;
		} else {
			return new Date(date.setDate(date.getDate() + workingDayFlag));
		}
	};

	const openURLOnCellClick = async (activeNode, id) => {
		try {
			// Fetching required URL
			const baseURL = checkExtraSlashAPIURL(userInfo.serverURL);
			const result = await axios.get(`${baseURL}${APP_CONSTANTS.CMIC_FIELD_REST__NAMES.apps_root_uri}`, {
				...handleLoginUserViaAuth2(userInfo),
			});
			// Creating required link as per given requirements
			const URL = createOpenURL(activeNode, result.data.uri, selectedProject.PmpVUuid, { VUuid: id });

			// Checking if we are processing a URL
			if (APP_CONSTANTS.URL_REGEX.test(URL)) {
				return URL;
			} else {
				setShowToast({
					isVisible: true,
					msg: `Unable to redirect at the moment`,
					type: MessageBarType.error,
				});

				return '';
			}
		} catch (error) {
			console.log('ERROR openURLOnCellClick()', error);
			setShowToast({
				isVisible: true,
				msg: `Unable to redirect at the moment`,
				type: MessageBarType.error,
			});
			return '';
		}
	};

	const onChangeEmailAutoFill = val => {
		if (!isInternetAvailable(setShowToast)) {
			return;
		}
		setAutoFillMailToggle(prev => {
			if (!prev) {
				Office.context.mailbox.item.body.getAsync(Office.CoercionType.Text, function (asyncResult) {
					if (asyncResult.status !== Office.AsyncResultStatus.Succeeded) {
						// TODO: Handle error
						console.log('OFFICE ERROR', asyncResult);
					} else {
						const subject = Office.context.mailbox.item.subject.substring(0, 200);

						setFieldsToCreateNewPMItems(prev => {
							return {
								...prev,
								HTMLQuestion: asyncResult.value,
								question: asyncResult.value,
								subject: subject,
								HTMLDescription: asyncResult.value,
								description: asyncResult.value,
								title: subject,
							};
						});
					}
				});
			} else {
				setFieldsToCreateNewPMItems(prev => {
					return {
						...prev,
						HTMLQuestion: '',
						subject: '',
						HTMLDescription: '',
						title: '',
					};
				});
			}
			return !prev;
		});
	};

	const handleCreateNewPMItem = isSaveDraftFlag => {
		if (!isInternetAvailable(setShowToast)) {
			return;
		}
		setIsSubmitted(true);

		const uuid = uuidv4();

		if (selectedNodeType === APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI) {
			if (
				fieldsToCreateNewPMItems.From.data !== undefined &&
				fieldsToCreateNewPMItems.responsibility.data !== undefined &&
				fieldsToCreateNewPMItems.status.data !== undefined &&
				fieldsToCreateNewPMItems.question.trim() !== '' &&
				fieldsToCreateNewPMItems.subject.trim() !== ''
			) {
				setIsLoading(true);
				let data = JSON.stringify({
					PmscrfiCompCode: selectedProject.PmpCompCode,
					PmscrfiFromContactCode: fieldsToCreateNewPMItems.From.data.PmpcContactCode,
					PmscrfiFromPartnCode: fieldsToCreateNewPMItems.From.data.PmpcPartnCode,
					PmscrfiFromPartnTypeCode: fieldsToCreateNewPMItems.From.data.PmpcPartnTypeCode,
					PmscrfiToContactCode: fieldsToCreateNewPMItems.responsibility.data.PmpcContactCode,
					PmscrfiToPartnCode: fieldsToCreateNewPMItems.responsibility.data.PmpcPartnCode,
					PmscrfiToPartnTypeCode: fieldsToCreateNewPMItems.responsibility.data.PmpcPartnTypeCode,
					PmscrfiStatusCode: fieldsToCreateNewPMItems.status.data.PmrfisStatusCode,
					PmscrfiRequiredDate: fieldsToCreateNewPMItems.date,
					PmscrfiCreateDate: new Date(),
					//PmscrfiStatusDesc: fieldsToCreateNewPMItems.status.data.PmrfisStatusName,
					PmscrfiQuestion: fieldsToCreateNewPMItems.question,
					PmscrfiProjOraseq: selectedProject.value,
					PmscrfiSubject: fieldsToCreateNewPMItems.subject,
					PmscrfiRecordStatus: isSaveDraftFlag
						? APP_CONSTANTS.PM_RECORD_STATUS.PENDING
						: APP_CONSTANTS.PM_RECORD_STATUS.SUBMITTED,
					VUuid: uuid,
				});

				let headers = {
					'Content-Type': 'application/vnd.oracle.adf.resourceitem+json',
				};

				if (userInfo?.isCloudUser || userInfo?.isEnterpriseOAuth) {
					headers.Authorization = `Bearer ${userInfo?.accessToken}`;
				}

				let config = {
					method: 'post',
					maxBodyLength: Infinity,
					url: `${userInfo.serverURL}${APP_CONSTANTS.CMIC_FIELD_REST__NAMES.rfisv12}`,
					...(userInfo?.isCloudUser || userInfo?.isEnterpriseOAuth
						? {}
						: {
							auth: {
								username: userInfo.username,
								password: userInfo.password,
							},
						}),
					headers: headers,
					data: data,
				};

				axios
					.request(config)
					.then(async response => {
						// Upload email as attachment
						if (selectedEmailContent.isAttached === true) {
							const bodyContent = await new Promise((resolve, reject) => {
								Office.context.mailbox.item.body.getAsync(Office.CoercionType.Text, result => {
									if (result.status === Office.AsyncResultStatus.Succeeded) {
										resolve(result.value);
									} else {
										reject(new Error(result.error));
									}
								});
							});
							if (!bodyContent) {
								setShowToast({
									isVisible: true,
									msg: 'Unable to fetch email body content',
									type: MessageBarType.error,
								});
								return;
							}
							const cleanBodyContext = removeEmojis(bodyContent);
							const cleanSubject = removeEmojis(Office.context.mailbox.item?.subject.replace(/:/g, ''));
							const recipients = Office.context.mailbox.item?.to
								?.map(recipient => `"${recipient.displayName}" <${recipient.emailAddress}>`)
								.join(', ');
							const blobHeaders = [
								`From: "${Office.context.mailbox.item?.from?.displayName}" <${Office.context.mailbox.item?.from?.emailAddress}>`,
								`To: ${recipients}`,
								`Subject: ${cleanSubject}`,
								'Content-Type: text/html; charset="utf-8"',
								'MIME-Version: 1.0',
								'',
								'',
							].join('\r\n');
							const blobBody = new Blob([blobHeaders, cleanBodyContext], {
								type: 'text/html; charset=utf-8',
							});
							const mailDataToUpload = {
								blob: blobBody,
								name: `${cleanSubject.substring(0, 200)}.eml`,
								isAttached: true,
								isMailContent: true,
							};
							await createPMDocumentRecord(response.data, mailDataToUpload);
						}
						//Attachment(s) for upload
						let index = 0;
						if (attachmentData.length) {
							for (const mailData of attachmentData) {
								await createPMDocumentRecord(response.data, { ...mailData, index });
								index++;
							}
						}

						return response;
					})
					.then(async response => {
						const URL = await openURLOnCellClick(APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_RFI, uuid);
						let failedAttachmentNames = '';
						let attchObjTrack = [];

						setAttachmentData(prev => {
							let failedAttachments = [];
							let checkFlagUploadAttachment = false;

							failedAttachments = prev.map(data => {
								attchObjTrack.push(data);
								if (data.isUploaded !== true) {
									checkFlagUploadAttachment = true;
									return data;
								}
							});

							if (checkFlagUploadAttachment) {
								if (failedAttachments.length === 1) {
									failedAttachments.forEach(element => {
										failedAttachmentNames = `${failedAttachmentNames} ${element.name}`;
									});
								} else if (failedAttachments.length > 1) {
									failedAttachments.forEach((element, index) => {
										if (index === failedAttachments.length - 1) {
											failedAttachmentNames = `${failedAttachmentNames} ${element?.name}`;
										} else {
											failedAttachmentNames = `${failedAttachmentNames} ${element?.name}, `;
										}
									});
								}
							}
							return prev;
						});

						// Adding prompt with inbuilt URL to have PM object's details

						handleSwitchToBrowse(
							{
								name: 'RFI',
								nodeId: response.data?.PmscrfiRfiOraseq,
								uuid: response?.data?.PmscrfiRfiId || '--',
							},
							selectedNodeType,
							URL,
							failedAttachmentNames,
							isSaveDraftFlag,
						);
						if (userInfo.actionRole === APP_CONSTANTS.ACTION_ROLE.PROJECT && userInfo?.isCloudUser) {
							segmentTrackCall('RFI', 'success', isSaveDraftFlag, response.data, attchObjTrack);
						}
					})
					.catch(error => {
						if (userInfo.actionRole === APP_CONSTANTS.ACTION_ROLE.PROJECT && userInfo?.isCloudUser)
							segmentTrackCall('RFI', 'fail', isSaveDraftFlag);
						console.log('handleCreateNewPMItem() Error', error);
						setIsLoading(false);
						setShowToast({
							isVisible: true,
							msg: `Unable to Create ${actionTypeData.label}`,
							type: MessageBarType.error,
						});
					});
			} else {
				setShowToast({
					isVisible: true,
					msg: 'Please fill mandatory fields',
					type: MessageBarType.warning,
				});
			}
		} else if (selectedNodeType === APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE) {
			if (
				fieldsToCreateNewPMItems.title.trim() !== '' &&
				fieldsToCreateNewPMItems.description.trim() !== '' &&
				fieldsToCreateNewPMItems.From.data !== undefined &&
				fieldsToCreateNewPMItems.status.data !== undefined &&
				fieldsToCreateNewPMItems.severity.data !== undefined &&
				fieldsToCreateNewPMItems.type.data !== undefined &&
				fieldsToCreateNewPMItems.responsibility.data !== undefined
			) {
				setIsLoading(true);
				let data = JSON.stringify({
					VUuid: uuid,
					DmiTitle: fieldsToCreateNewPMItems.title?.substring(0, 60),
					DmiCompCode: selectedProject.PmpCompCode,
					DmiProjOraseq: selectedProject.value,
					DmiUser: userInfo.info.pmUser,
					DmiDate: new Date(),
					DmiInternalFlag: 'N',
					DmiPartnCode: fieldsToCreateNewPMItems.From.data.PmpcPartnCode,
					DmiPartnTypeCode: fieldsToCreateNewPMItems.From.data.PmpcPartnTypeCode,
					DmiContactCode: fieldsToCreateNewPMItems.From.data.PmpcContactCode,
					DmiStatusCode: fieldsToCreateNewPMItems.status.data.DmisStatusCode,
					DmiStatusDesc: fieldsToCreateNewPMItems.status.data.DmisDesc,
					DmiPriorityCode: fieldsToCreateNewPMItems.severity.data.DmipPriorityCode,
					DmiPriorityDesc: fieldsToCreateNewPMItems.severity.data.DmipDesc,
					DmiRespPartnCode: fieldsToCreateNewPMItems.responsibility.data.PmpcPartnCode,
					DmiRespPartnTypeCode: fieldsToCreateNewPMItems.responsibility.data.PmpcPartnTypeCode,
					DmiRespContactCode: fieldsToCreateNewPMItems.responsibility.data.PmpcContactCode,
					DmiTypeCode: fieldsToCreateNewPMItems.type.data.DmitTypeCode,
					DmiToPartnCode: fieldsToCreateNewPMItems.responsibility.data.PmpcPartnCode,
					DmiToPartnTypeCode: fieldsToCreateNewPMItems.responsibility.data.PmpcPartnTypeCode,
					DmiToContactCode: fieldsToCreateNewPMItems.responsibility.data.PmpcContactCode,
					DmiDueDate: fieldsToCreateNewPMItems.date,
					DmiDescription: fieldsToCreateNewPMItems.description,
					//  DmiDueDate: "2023-06-17T18:53:14.699Z",
					DmiRecordStatus: isSaveDraftFlag
						? APP_CONSTANTS.PM_RECORD_STATUS.PENDING
						: APP_CONSTANTS.PM_RECORD_STATUS.SUBMITTED,
					//   DmiIuCreateDate: "2023-06-12T18:47:01.355Z"
				});

				let headers = {
					'Content-Type': 'application/vnd.oracle.adf.resourceitem+json',
				};

				if (userInfo?.isCloudUser || userInfo?.isEnterpriseOAuth) {
					headers.Authorization = `Bearer ${userInfo?.accessToken}`;
				}

				let config = {
					method: 'post',
					maxBodyLength: Infinity,
					url: `${userInfo.serverURL}${APP_CONSTANTS.CMIC_FIELD_REST__NAMES.issues}`,
					...(userInfo?.isCloudUser || userInfo?.isEnterpriseOAuth
						? {}
						: {
							auth: {
								username: userInfo.username,
								password: userInfo.password,
							},
						}),
					headers: headers,
					data: data,
				};

				axios
					.request(config)
					.then(async response => {
						// Upload email as attachment
						if (selectedEmailContent.isAttached === true) {
							const bodyContent = await new Promise((resolve, reject) => {
								Office.context.mailbox.item.body.getAsync(Office.CoercionType.Text, result => {
									if (result.status === Office.AsyncResultStatus.Succeeded) {
										resolve(result.value);
									} else {
										reject(new Error(result.error));
									}
								});
							});
							if (!bodyContent) {
								setShowToast({
									isVisible: true,
									msg: 'Unable to fetch email body content',
									type: MessageBarType.error,
								});
								return;
							}
							const cleanBodyContext = removeEmojis(bodyContent);
							const cleanSubject = removeEmojis(Office.context.mailbox.item?.subject.replace(/:/g, ''));
							const recipients = Office.context.mailbox.item?.to
								?.map(recipient => `"${recipient.displayName}" <${recipient.emailAddress}>`)
								.join(', ');
							const blobHeaders = [
								`From: "${Office.context.mailbox.item?.from?.displayName}" <${Office.context.mailbox.item?.from?.emailAddress}>`,
								`To: ${recipients}`,
								`Subject: ${cleanSubject}`,
								'Content-Type: text/html; charset="utf-8"',
								'MIME-Version: 1.0',
								'',
								'',
							].join('\r\n');
							const blobBody = new Blob([blobHeaders, cleanBodyContext], {
								type: 'text/html; charset=utf-8',
							});
							const mailDataToUpload = {
								blob: blobBody,
								name: `${cleanSubject.substring(0, 200)}.eml`,
								isAttached: true,
								isMailContent: true,
							};
							await createPMDocumentRecord(response.data, mailDataToUpload);
						}
						let index = 0;
						if (attachmentData.length) {
							for (const mailData of attachmentData) {
								await createPMDocumentRecord(response.data, { ...mailData, index });
								index++;
							}
						}
						return response;
					})
					.then(async response => {
						const URL = await openURLOnCellClick(APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_ISSUE, uuid);
						let failedAttachmentNames = '';
						let attchObjTrack = [];

						setAttachmentData(prev => {
							let failedAttachments = [];
							let checkFlagUploadAttachment = false;

							failedAttachments = prev.map(data => {
								attchObjTrack.push(data);
								if (data.isUploaded !== true) {
									checkFlagUploadAttachment = true;
									return data;
								}
							});
							if (checkFlagUploadAttachment) {
								if (failedAttachments.length === 1) {
									failedAttachments.forEach(element => {
										failedAttachmentNames = `${failedAttachmentNames} ${element.name}`;
									});
									setShowToast({
										isVisible: true,
										msg: `Attachment failed to upload: - ${failedAttachmentNames}`,
										type: MessageBarType.error,
									});
								} else if (failedAttachments.length > 1) {
									failedAttachments.forEach((element, index) => {
										if (index === failedAttachments.length - 1) {
											failedAttachmentNames = `${failedAttachmentNames} ${element.name}`;
										} else {
											failedAttachmentNames = `${failedAttachmentNames} ${element.name}, `;
										}
									});
								}
							}
							return prev;
						});
						// Adding prompt with inbuilt URL to have PM object's details
						handleSwitchToBrowse(
							{
								name: 'Issue',
								nodeId: response.data?.DmiIssueOraseq,
								uuid: response?.data?.DmiIssueId || '--',
							},
							selectedNodeType,
							URL,
							failedAttachmentNames,
							isSaveDraftFlag,
						);
						if (userInfo.actionRole === APP_CONSTANTS.ACTION_ROLE.PROJECT && userInfo?.isCloudUser)
							segmentTrackCall('ISSUE', 'success', isSaveDraftFlag, response.data, attchObjTrack);
					})
					.catch(error => {
						if (userInfo.actionRole === APP_CONSTANTS.ACTION_ROLE.PROJECT && userInfo?.isCloudUser)
							segmentTrackCall('ISSUE', 'fail', isSaveDraftFlag);
						console.log('handleCreateNewPMItem() Error', error);
						setIsLoading(false);
						setShowToast({
							isVisible: true,
							msg: `Unable to Create ${actionTypeData.label}`,
							type: MessageBarType.error,
						});
					});
			} else {
				setShowToast({
					isVisible: true,
					msg: 'Please fill mandatory fields',
					type: MessageBarType.error,
				});
			}
		} else if (selectedNodeType === APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_COMMUNICATION) {
			///TODO
		}
	};

	const segmentTrackCall = (nodeType, status, isSaveDraftFlag, obj = [], attchObjTrack = []) => {
		let attachmentObj = [];

		if (attchObjTrack.length > 0) {
			attachmentObj = attchObjTrack.map(prev => {
				return {
					id: prev.id,
					name: prev.name,
					status: prev.isUploaded ? 'success' : 'failed',
				};
			});
		}

		const segmentObj = {
			contactCode: userInfo?.info?.contactCode,
			timeStamp: new Date(),
			projectName: selectedProject?.PmpProjName,
			projectId: selectedProject?.PmpVUuid,
			isAutofill: autoFillMailToggle,
			status: status,
			isAttachment: attachmentData.length > 0 ? 'Yes' : 'No',
			attachments: attachmentObj,
		};

		let eventName = 'RFI_CREATED';

		if (nodeType === APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI) {
			segmentObj.RFIId = obj?.PmscrfiRfiId;
			if (!isSaveDraftFlag) eventName = 'RFI_CREATED';
			else eventName = 'RFI_DRAFT';
		} else if (nodeType === APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE) {
			segmentObj.IssueId = obj?.DmiIssueId;
			if (!isSaveDraftFlag) eventName = 'ISSUE_CREATED';
			else eventName = 'ISSUE_DRAFT';
		}
		segmentDefaultTrackCall(eventName, segmentObj);
		//console.log(eventName,segmentObj)
	};

	const createPMDocumentRecord = (PMData, mailData) => {
		const uuid = uuidv4();
		return new Promise(resolve => {
			const mailDataName = mailData.isMailContent
				? `${removeEmojis(Office.context.mailbox.item?.subject.replace(/:/g, ''))}.eml`
				: removeEmojis(mailData.name).replace(/:/g, '');
			let data = JSON.stringify({
				PmdCompCode: selectedProject.PmpCompCode,
				PmdContactCode: fieldsToCreateNewPMItems.From.data.PmpcContactCode,
				PmdMpowerUser: userInfo.info.pmUser,
				PmdPartnCode: fieldsToCreateNewPMItems.From.data.PmpcPartnCode,
				PmdPartnTypeCode: fieldsToCreateNewPMItems.From.data.PmpcPartnTypeCode,
				PmdProjOraseq: selectedProject.value,
				PmdStatusCode: null,
				PmdTitle: mailDataName,
				PmdTypeCode: 'ATTACHMENT',
				VUuid: uuid,
				PmdrVUuid: uuid,
			});

			let headers = {
				'Content-Type': 'application/vnd.oracle.adf.resourceitem+json',
			};

			if (userInfo?.isCloudUser || userInfo?.isEnterpriseOAuth) {
				headers.Authorization = `Bearer ${userInfo?.accessToken}`;
			}

			const fileName = hashFileName(mailDataName);
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${userInfo.serverURL}${APP_CONSTANTS.CMIC_FIELD_REST__NAMES.documents}?filename=${fileName}`,
				...(userInfo?.isCloudUser || userInfo?.isEnterpriseOAuth
					? {}
					: {
						auth: {
							username: userInfo.username,
							password: userInfo.password,
						},
					}),
				headers: headers,
				data: data,
			};

			axios
				.request(config)
				.then(async response => {
					resolve(await uploadDocumentsToRecord(PMData, response.data, mailData));
				})
				.catch(err => {
					resolve(false);
					console.log('Document Creation Error', err);
				});
		});
	};

	const uploadDocumentsToRecord = async (PMData, recordData, mailData) => {
		return new Promise((resolve, reject) => {
			let data = new FormData();
			let blobData = {};
			if (mailData.isMailContent) {
				blobData = mailData.blob;
			} else {
				blobData = downloadAttachmentLocally(mailData);
			}
			const fileName = hashFileName(mailData.name.replace(/:/g, ''));
			data.append('document-content-file', blobData, fileName);

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${userInfo.serverURL}${APP_CONSTANTS.CMIC_FIELD_REST__NAMES.documents}/${recordData.VUuid}`,
				...handleLoginUserViaAuth2(userInfo),
				body: data,
				data: data,
			};

			axios
				.request(config)
				.then(async response => {
					await attachUploadedDocumentToPMObject(PMData, recordData, mailData);
					resolve(response.data);
				})
				.catch(err => {
					setIsLoading(false);
					setShowToast({
						isVisible: true,
						msg: 'Upload Error',
						type: MessageBarType.error,
					});
					console.log(err);
					resolve(false);
				});
		});
	};

	const attachUploadedDocumentToPMObject = (PMData, recordData, mailData) => {
		return new Promise((resolve, reject) => {
			let data = {};
			let url = '';
			let pmObjectOraseq = '';
			if (selectedNodeType === APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI) {
				((url = `${userInfo.serverURL}${APP_CONSTANTS.CMIC_FIELD_REST__NAMES.rfisv12}/${PMData.VUuid}/child/RelatedDocumentView`),
					(pmObjectOraseq = PMData.PmscrfiRfiOraseq));
				data = JSON.stringify({
					VUuid: uuidv4(),
					SysrdAttName: '',
					SysrdAttPath: mailData.name,
					SysrdContactCode: userInfo.info.contactCode, //PMData.PmscrfiFromContactCode,
					SysrdContactName: `${userInfo.info.firstName} ${userInfo.info.lastName}`, //PMData.PmscrfiFromContactName,
					SysrdDocId: recordData.PmdId,
					SysrdDocTitle: PMData.PmscrfiRfiId,
					SysrdDocTypeCode: 'ATTACHMENT',
					SysrdDocTypeName: 'Attachment',
					SysrdObjectType: APP_CONSTANTS.CMIC_OBJECT_CODES.RFI_OBJECT_CODE,
					SysrdPartnCode: userInfo.info.partnerCode,
					SysrdPartnTypeCode: userInfo.info.partnerTypeCode,
					SysrdProjOraseq: selectedProject.value,
					SysrdRevNum: 0,
					SysrdStatus: 'OPEN',
					SysrdDocVUuid: recordData.VUuid,
					SysrdObjectVUuid: PMData.VUuid,
					SysrdRevisionVUuid: recordData.DocRevisionView[0].VUuid,
				});
			}

			if (selectedNodeType === APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE) {
				((url = `${userInfo.serverURL}${APP_CONSTANTS.CMIC_FIELD_REST__NAMES.issues}/${PMData.VUuid}/child/RelatedDocumentView`),
					(pmObjectOraseq = PMData.DmiProjOraseq));
				data = JSON.stringify({
					VUuid: uuidv4(),
					SysrdAttName: '',
					SysrdAttPath: mailData.name,
					SysrdContactCode: userInfo.info.contactCode, // PMData.DmiContactCode,
					SysrdContactName: `${userInfo.info.firstName} ${userInfo.info.lastName}`, // PMData.DmiContactName,
					SysrdDocId: recordData.PmdId,
					SysrdDocTitle: PMData.DmiIssueId,
					SysrdDocTypeCode: 'ATTACHMENT',
					SysrdDocTypeName: 'Attachment',
					SysrdObjectType: APP_CONSTANTS.CMIC_OBJECT_CODES.ISSUE_OBJECT_CODE,
					SysrdPartnCode: userInfo.info.partnerCode,
					SysrdPartnTypeCode: userInfo.info.partnerTypeCode,
					SysrdProjOraseq: selectedProject.value,
					SysrdRevNum: 0,
					SysrdStatus: 'OPEN',
					SysrdDocVUuid: recordData.VUuid,
					SysrdObjectVUuid: PMData.VUuid,
					SysrdRevisionVUuid: recordData.DocRevisionView[0].VUuid,
				});
			}

			let headers = {
				'Content-Type': 'application/vnd.oracle.adf.resourceitem+json',
			};

			if (userInfo?.isCloudUser || userInfo?.isEnterpriseOAuth) {
				headers.Authorization = `Bearer ${userInfo?.accessToken}`;
			}

			// check condition if data is not null
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: url,
				...(userInfo?.isCloudUser || userInfo?.isEnterpriseOAuth
					? {}
					: {
						auth: {
							username: userInfo.username,
							password: userInfo.password,
						},
					}),
				headers: headers,
				data: data,
			};

			axios
				.request(config)
				.then(response => {
					setAttachmentData(prev => {
						let newAttachedData = prev.map(data => {
							if (data.id === mailData.id) {
								return { ...mailData, isUploaded: true };
							} else return data;
						});
						return newAttachedData;
					});
					resolve(response.data);
				})
				.catch(err => {
					setIsLoading(false);
					setShowToast({
						isVisible: true,
						msg: `Unable to Create ${actionTypeData.label}`,
						type: MessageBarType.error,
					});
					console.log(err);
					resolve(false);
				});
		});
	};

	const fetchNFilterConcatData = async (searchOption = '', offset = 0) => {
		try {
			const fieldDetails = await fetchFieldsData(APP_CONSTANTS.CMIC_FIELD_REST__NAMES.contacts, userInfo, {
				projOraseq: selectedProject.value,
				firstName: searchOption,
				offset: offset,
			});

			const result = [];

			fieldDetails.items.forEach(value => {
				const firstName = value?.PmpcFirstName || '';
				const lastName = value?.PmpcLastName || '';

				if (
					!searchOption ||
					firstName.toLowerCase().includes(searchOption) ||
					lastName.toLowerCase().includes(searchOption)
				) {
					result.push({
						key: value.PmpcContactOraseq,
						label: `${value.PmpcFirstName} ${value.PmpcLastName}`,
						data: value,
					});
				}
			});

			return {
				...fieldDetails,
				items: result,
				offset: offset + 1,
			};
		} catch (error) {
			console.log('fetchNFilterConcatData() ERROR', error);
			return INIT_CONCATS_CONFIG;
		}
	};

	const searchFieldOptimized = async (searchOption = '') => {
		if (!isInternetAvailable(setShowToast)) {
			return;
		}
		if (timer.current) clearTimeout(timer.current);
		// Added delay to prevent API calling for every key pressed
		return new Promise((resolve, reject) => {
			timer.current = setTimeout(async () => {
				const concats = await fetchNFilterConcatData(searchOption, 0);

				setResponsibility({
					...concats,
					search: searchOption,
				});

				resolve(concats.items);
				clearTimeout(timer.current);
				timer.current = null;
			}, 800);
		});
	};

	const fetchConcatsOnLoadMore = async () => {
		if (!responsibility.hasMore) return responsibility.items;

		const concats = await fetchNFilterConcatData(responsibility.search, responsibility.offset);

		setResponsibility(prev => ({
			...concats,
			items: [...prev.items, ...concats.items],
		}));
	};

	const handleFieldChange = (name, val) => {
		setFieldsToCreateNewPMItems(prev => {
			return {
				...prev,
				[name]: val,
			};
		});
	};

	const CaretDownIcon = () => {
		return <span className="material-symbols-outlined">arrow_drop_down</span>;
	};

	const DropdownIndicator = props => {
		if (
			props.selectProps.label === 'From' ||
			props.selectProps.label === 'To' ||
			props.selectProps.label === 'Responsibility'
		) {
			return (
				<components.DropdownIndicator {...props}>
					<SearchIcon />
				</components.DropdownIndicator>
			);
		} else {
			return (
				<components.DropdownIndicator {...props}>
					<CaretDownIcon />
				</components.DropdownIndicator>
			);
		}
	};

	const SearchIcon = () => {
		return <span className="material-symbols-outlined">search</span>;
	};

	const text_theme = handleTextTheme({ themeId: currentOfficeTheme.themeId });

	const HeaderUI = () => {
		return (
			<>
				<Stack
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						paddingRight: '8px',
						width: '100%',
					}}
					horizontal
					tokens={stackTokens}
				>
					<Stack horizontal style={{ flex: 1, display: 'flex' }}>
						<BorderIcon
							iconStyles={{
								color: COLORS.OUTLOOK_PRIMARY_BUTTON_COLOR,
								fontWeight: 'bold',
								fontSize: '18px',
							}}
							parentStyles={{ marginRight: '2%', marginLeft: '2px', marginTop: '1px' }}
							iconName="Back"
							onClick={() => {
								navigate.replace('/home');
								setActionTypeData({
									nodeType: null,
									label: null,
									type: null,
								});
								setSelectedEmailContent(prev => {
									return { ...prev, isAttached: false };
								});
							}}
						/>
						<strong style={headerStyles}>{header}</strong>
					</Stack>

					<Stack
						className={handleTHEMECLR(currentOfficeTheme)}
						id="demo-customized-button"
						aria-controls={'demo-customized-menu'}
						aria-haspopup="true"
						variant="contained"
						disableElevation
						onClick={() => handleCreateNewPMItem(false)}
						style={{
							display: 'flex',
							margin: '1px 5px',
							padding: '3px 4px',
							alignItems: 'center',
							justifyContent: 'center',
							cursor: 'pointer',
							border:
								currentOfficeTheme.themeId === THEME_ID.BLACK ||
									currentOfficeTheme.themeId === THEME_ID.DARK_GREY
									? `0.8px solid ${currentOfficeTheme.bodyForegroundColor}`
									: '1px solid rgba(174, 180, 189, 1)',
						}}
					>
						<MdCloudUpload
							style={{
								color: COLORS.PURPLE,
								height: '25px',
								width: '25px',
							}}
						/>
					</Stack>
					<CustomizedMenus
						onChangeEmailAutoFill={onChangeEmailAutoFill}
						handleCreateNewPMItem={handleCreateNewPMItem}
					/>
				</Stack>
				<Divider
					style={{
						background:
							currentOfficeTheme.themeId === THEME_ID.BLACK ||
								currentOfficeTheme.themeId === THEME_ID.DARK_GREY
								? currentOfficeTheme.bodyForegroundColor
								: 'rgb(128,128,128, 0.4)',
					}}
				/>
			</>
		);
	};

	if (isLoading) {
		return (
			<div style={loaderStyles}>
				<Spinner
					color={isBGClrDark() ? COLORS.OUTLOOK_LIGHT_BLUE : COLORS.OUTLOOK_DARK_BLUE}
					size={SpinnerSize.large}
					label="Almost there..."
				/>
			</div>
		);
	}

	const showFormUI = nodeType => {
		switch (nodeType) {
			case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI:
				return (
					<>
						<Stack.Item>
							<FormControl sx={{ width: '100%' }} size="small">
								<label aria-label="Subject" style={headerTextStyle} htmlFor="subject">
									Subject
								</label>
								<TextField
									value={fieldsToCreateNewPMItems.subject}
									placeholder=""
									id="subject"
									name="subject"
									aria-label="Enter a subject"
									autoComplete="off"
									className={text_theme}
									autoAdjustHeight
									autoFocus
									aria-required
									maxLength={200}
									styles={textInputStyles}
									invalid={isSubmitted && !fieldsToCreateNewPMItems.subject}
									onChange={(event, option, index) => {
										handleFieldChange(event?.target?.name, option.substring(0, 200));
									}}
								/>
							</FormControl>
						</Stack.Item>

						<Stack.Item>
							<FormControl sx={{ width: '100%' }} size="small">
								<label aria-label="Status" style={headerTextStyle} htmlFor="status">
									Status
								</label>
								<Select
									options={status}
									value={fieldsToCreateNewPMItems.status}
									placeholder=""
									name="status"
									id="status"
									label="Status"
									aria-label="Status options"
									onChange={(data, event) => {
										handleFieldChange(event.name, data);
									}}
									isSearchable={true}
									required
									components={{ DropdownIndicator }}
									menuPortalTarget={document.body}
									aria-errormessage="Status is a required field."
									styles={
										isSubmitted && !fieldsToCreateNewPMItems.status
											? invalidCustomStyles(currentOfficeTheme)
											: customStyles(currentOfficeTheme)
									}
								/>
							</FormControl>
						</Stack.Item>

						<Stack.Item style={{ display: 'flex', flexDirection: 'row', alignItems: 'end' }}>
							<FormControl sx={{ minWidth: 120 }} size="small">
								<div style={{ display: 'flex', flexDirection: 'row', margin: '3px 0px 3px 0px' }}>
									<label aria-label="Required Date" style={headerTextStyle} htmlFor="Created Date">
										Required Date
									</label>
								</div>
								<DatePicker
									firstWeekOfYear={1}
									showMonthPickerAsOverlay={true}
									styles={datePickerStyles}
									style={{ width: '145px' }}
									calendarProps={datePickerCalendarStyles}
									id="Required Date"
									aria-label="Required Date"
									autoAdjustHeight
									minDate={new Date()}
									onSelectDate={(event, option, index) => {
										setFieldsToCreateNewPMItems(prev => {
											return {
												...prev,
												date: event,
											};
										});
									}}
									placeholder=""
									showGoToToday
									ariaLabel="Select a date"
									strings={defaultDatePickerStrings}
									value={
										fieldsToCreateNewPMItems.date
											? fieldsToCreateNewPMItems.date
											: new Date(new Date().setDate(new Date().getDate() + 5))
									}
									formatDate={formatDate}
								/>
							</FormControl>
							<FormControl
								sx={{
									minWidth: 120,
									width: 'auto',
									verticalAlign: 'bottom',
									marginLeft: '32px',
									marginBottom: '2px',
									lineHeight: 0,
									'& .MuiTypography-body1': {
										lineHeight: 1,
										letterSpacing: '0px',
									},
								}}
								size="small"
							>
								<FormControlLabel
									sx={{
										fontFamily: baseFontFamilyStyle,
										'& .MuiTypography-body1': {
											lineHeight: 1,
										},
									}}
									aria-label="Select email content"
									checked={selectedEmailContent.isAttached}
									onChange={() => {
										setSelectedEmailContent(prev => {
											return {
												...prev,
												isAttached: !prev.isAttached,
											};
										});
									}}
									control={
										<Checkbox
											style={{ zIndex: 0 }}
											id="email"
											icon={<BpIcon />}
											checkedIcon={<BpCheckedIcon />}
										/>
									}
									label={
										<span
											style={{
												fontWeight: '6000',
												fontFamily: baseFontFamilyStyle,
												fontSize: 13,
												color:
													currentOfficeTheme.themeId === THEME_ID.BLACK ||
														currentOfficeTheme.themeId === THEME_ID.DARK_GREY
														? currentOfficeTheme.bodyForegroundColor
														: '#333333',
												margin: '0.6rem 3px',
											}}
										>
											<Tooltip
												title={`Upload base e-mail, used for populating subject and question, as an attachment.`}
												aria-label="Upload base e-mail, used for populating subject and question, as an attachment."
												componentsProps={{
													tooltip: {
														sx: {
															color: currentOfficeTheme.bodyForegroundColor,
															backgroundColor: currentOfficeTheme.bodyBackgroundColor,
															fontFamily: baseFontFamilyStyle,
															fontSize: '13px',
															border: '0.5px solid grey',
															padding: '5px',
														},
													},
												}}
											>
												Upload Email as Attachment
											</Tooltip>
										</span>
									}
								/>
							</FormControl>
						</Stack.Item>

						<Stack.Item>
							<FormControl sx={{ width: '100%' }} size="small">
								<label aria-label="From" style={headerTextStyle} htmlFor="From">
									From
								</label>
								<AsyncSelect
									value={isFromDropFocused ? '' : fieldsToCreateNewPMItems.From}
									defaultOptions={responsibility.items}
									placeholder=""
									label="From"
									name="From"
									aria-label="Please select a Project Contact"
									isSearchable
									required
									components={{ DropdownIndicator }}
									menuPortalTarget={document.body}
									loadOptions={searchFieldOptimized}
									onMenuScrollToBottom={fetchConcatsOnLoadMore}
									onInputChange={val => {
										if (!val) searchFieldOptimized();
									}}
									onChange={(data, event) => {
										handleFieldChange(event.name, data);
										setResponsibility([]);
										setIsFromDropFocused(false);
									}}
									onBlur={() => setIsFromDropFocused(false)}
									onMenuClose={() => setResponsibility([])}
									onMenuOpen={() => {
										searchFieldOptimized();
										setIsFromDropFocused(true);
									}}
									styles={
										isSubmitted && !fieldsToCreateNewPMItems.From
											? invalidCustomStyles(currentOfficeTheme)
											: customStyles(currentOfficeTheme)
									}
								/>
							</FormControl>
						</Stack.Item>

						<Stack.Item>
							<FormControl sx={{ width: '100%' }} size="small">
								<label aria-label="To" style={headerTextStyle} htmlFor="To">
									To
								</label>
								<AsyncSelect
									defaultOptions={responsibility.items}
									placeholder=""
									name="responsibility"
									label="To"
									aria-label="Please select a Project Contact"
									value={isToDropFocused ? '' : fieldsToCreateNewPMItems.responsibility}
									loadOptions={searchFieldOptimized}
									onMenuScrollToBottom={fetchConcatsOnLoadMore}
									onInputChange={val => {
										if (!val) searchFieldOptimized();
									}}
									onBlur={() => {
										setIsToDropFocused(false);
									}}
									onMenuOpen={() => {
										searchFieldOptimized();
										setIsToDropFocused(true);
									}}
									onMenuClose={() => setResponsibility([])}
									onChange={(data, event) => {
										handleFieldChange(event.name, data);
										setIsToDropFocused(false);
									}}
									isSearchable={true}
									required
									components={{ DropdownIndicator }}
									menuPortalTarget={document.body}
									styles={
										isSubmitted && !fieldsToCreateNewPMItems.responsibility
											? invalidCustomStyles(currentOfficeTheme)
											: customStyles(currentOfficeTheme)
									}
								/>
							</FormControl>
						</Stack.Item>

						<Stack.Item>
							<FormControl
								sx={{
									width: '100%',
								}}
								size="small"
							>
								<label aria-label="Question" style={headerTextStyle}>
									Question
								</label>
								<textarea
									ref={textareaRefCallback}
									name="question"
									aria-label="Question field"
									className={`create-actions-textarea ${isSubmitted && !fieldsToCreateNewPMItems.HTMLQuestion ? 'is-invalid' : ''
										}`}
									value={fieldsToCreateNewPMItems?.HTMLQuestion || ''}
									onChange={(e) => {
										handleFieldChange('HTMLQuestion', e.target.value);
										handleFieldChange('question', e.target.value);
										autoResizeTextarea(e);
									}}
									rows={6}
									style={{
										'--ca-bg': currentOfficeTheme.bodyBackgroundColor,
										'--ca-fg': currentOfficeTheme.bodyForegroundColor,
										'--ca-border': COLORS.BORDER_COLOR,
										'--ca-invalid-border': COLORS.RED,
										'--ca-font-family': baseFontFamilyStyle,
									}}
									maxlength="4000"
								/>
							</FormControl>
						</Stack.Item>
					</>
				);
			case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE:
				return (
					<>
						<Stack.Item>
							<FormControl sx={{ width: '100%' }} size="small">
								<label aria-label="Subject" style={headerTextStyle} htmlFor="subject">
									Subject
								</label>
								<TextField
									className={text_theme}
									placeholder=""
									name="title"
									aria-label="Enter a Subject"
									autoComplete="off"
									maxLength={60}
									autoAdjustHeight
									styles={textInputStyles}
									value={fieldsToCreateNewPMItems.title?.substring(0, 60)}
									aria-required
									aria-errormessage="Subject is a required field"
									invalid={isSubmitted && !fieldsToCreateNewPMItems.title}
									onChange={(event, option, index) => {
										handleFieldChange(event?.target?.name, option.substring(0, 60));
									}}
								/>
							</FormControl>
						</Stack.Item>

						<Stack.Item>
							<FormControl sx={{ width: '100%' }} size="small">
								<label aria-label="Type" style={headerTextStyle} htmlFor="Type">
									Type
								</label>
								<Select
									options={type}
									placeholder=""
									name="type"
									aria-label="Select a Type"
									value={fieldsToCreateNewPMItems.type}
									onChange={(data, event) => {
										handleFieldChange(event.name, data);
									}}
									isSearchable={true}
									required
									components={{ DropdownIndicator }}
									menuPortalTarget={document.body}
									label="Type"
									styles={
										isSubmitted && !fieldsToCreateNewPMItems.type
											? invalidCustomStyles(currentOfficeTheme)
											: customStyles(currentOfficeTheme)
									}
								/>
							</FormControl>
						</Stack.Item>

						<Stack.Item>
							<FormControl sx={{ width: '100%' }} size="small">
								<label aria-label="Status" style={headerTextStyle} htmlFor="Staus">
									Status
								</label>
								<Select
									options={status}
									placeholder=""
									name="status"
									aria-label="Select a status"
									value={fieldsToCreateNewPMItems.status}
									onChange={(data, event) => {
										handleFieldChange(event.name, data);
									}}
									isSearchable={true}
									required
									components={{ DropdownIndicator }}
									menuPortalTarget={document.body}
									label="Status"
									styles={
										isSubmitted && !fieldsToCreateNewPMItems.status
											? invalidCustomStyles(currentOfficeTheme)
											: customStyles(currentOfficeTheme)
									}
								/>
							</FormControl>
						</Stack.Item>

						<Stack.Item>
							<FormControl sx={{ width: '100%' }} size="small">
								<label style={headerTextStyle} htmlFor="Severity">
									Severity
								</label>
								<Select
									options={severity}
									placeholder=""
									value={fieldsToCreateNewPMItems.severity}
									name="severity"
									label="Severity"
									aria-label="Severity"
									onChange={(data, event) => {
										handleFieldChange(event.name, data);
									}}
									isSearchable={true}
									required
									components={{ DropdownIndicator }}
									menuPortalTarget={document.body}
									styles={
										isSubmitted && !fieldsToCreateNewPMItems.severity
											? invalidCustomStyles(currentOfficeTheme)
											: customStyles(currentOfficeTheme)
									}
								/>
							</FormControl>
						</Stack.Item>

						<Stack.Item style={{ display: 'flex', flexDirection: 'row', alignItems: 'end' }}>
							<FormControl sx={{ minWidth: 120 }} size="small">
								<div style={{ display: 'flex', flexDirection: 'row', margin: '3px 0px 3px 0px' }}>
									<label aria-label="Required Date" style={headerTextStyle} htmlFor="Created Date">
										Required Date
									</label>
								</div>
								<DatePicker
									firstWeekOfYear={1}
									showMonthPickerAsOverlay={true}
									styles={datePickerStyles}
									style={{ width: '145px' }}
									calendarProps={datePickerCalendarStyles}
									id="Required Date"
									aria-label="Required Date"
									autoAdjustHeight
									minDate={new Date()}
									onSelectDate={(event, option, index) => {
										setFieldsToCreateNewPMItems(prev => {
											return {
												...prev,
												date: event,
											};
										});
									}}
									placeholder=""
									showGoToToday
									ariaLabel="Select a date"
									strings={defaultDatePickerStrings}
									value={
										fieldsToCreateNewPMItems.date
											? fieldsToCreateNewPMItems.date
											: new Date(new Date().setDate(new Date().getDate() + 5))
									}
									formatDate={formatDate}
								/>
							</FormControl>
							<FormControl
								sx={{
									minWidth: 120,
									width: 'auto',
									verticalAlign: 'bottom',
									marginLeft: '32px',
									marginBottom: '2px',
									lineHeight: 0,
									'& .MuiTypography-body1': {
										lineHeight: 1,
										letterSpacing: '0px',
									},
								}}
								size="small"
							>
								<FormControlLabel
									sx={{
										fontFamily: baseFontFamilyStyle,
										lineHeight: 0,
										'& .MuiTypography-body1': {
											lineHeight: 0,
										},
									}}
									checked={selectedEmailContent.isAttached}
									onChange={() => {
										setSelectedEmailContent(prev => {
											return {
												...prev,
												isAttached: !prev.isAttached,
											};
										});
									}}
									control={
										<Checkbox
											style={{ zIndex: 0 }}
											icon={<BpIcon />}
											checkedIcon={<BpCheckedIcon />}
										/>
									}
									label={
										<span
											style={{
												fontWeight: '6000',
												fontFamily: baseFontFamilyStyle,
												fontSize: 13,
												color:
													currentOfficeTheme.themeId === THEME_ID.BLACK ||
														currentOfficeTheme.themeId === THEME_ID.DARK_GREY
														? currentOfficeTheme.bodyForegroundColor
														: '#333333',
												margin: '0.6rem 3px',
											}}
										>
											<Tooltip
												title={`Upload base e-mail, used for populating subject and description, as an attachment.`}
												componentsProps={{
													tooltip: {
														sx: {
															color: currentOfficeTheme.bodyForegroundColor,
															backgroundColor: currentOfficeTheme.bodyBackgroundColor,
															fontSize: '13px',
															border: '0.5px solid grey',
															padding: '5px',
														},
													},
												}}
											>
												Upload Email as Attachment
											</Tooltip>
										</span>
									}
								/>
							</FormControl>
						</Stack.Item>

						<Stack.Item>
							<FormControl sx={{ width: '100%' }} size="small">
								<label aria-label="From" style={headerTextStyle} htmlFor="From">
									From
								</label>
								<AsyncSelect
									defaultOptions={responsibility.items}
									placeholder=""
									label="From"
									id="From"
									name="From"
									aria-label="Please select a Project Contact"
									value={isFromDropFocused ? '' : fieldsToCreateNewPMItems.From}
									loadOptions={searchFieldOptimized}
									menuPortalTarget={document.body}
									onMenuScrollToBottom={fetchConcatsOnLoadMore}
									onInputChange={val => {
										if (!val) searchFieldOptimized();
									}}
									onChange={(data, event) => {
										handleFieldChange(event.name, data);
										setResponsibility([]);
										setIsFromDropFocused(false);
									}}
									onBlur={() => setIsFromDropFocused(false)}
									onMenuOpen={() => {
										searchFieldOptimized();
										setIsFromDropFocused(true);
									}}
									isSearchable={true}
									required
									components={{ DropdownIndicator }}
									styles={
										isSubmitted && !fieldsToCreateNewPMItems.From
											? invalidCustomStyles(currentOfficeTheme)
											: customStyles(currentOfficeTheme)
									}
								/>
							</FormControl>
						</Stack.Item>

						<Stack.Item>
							<FormControl sx={{ width: '100%' }} size="small">
								<label aria-label="Responsibility" style={headerTextStyle} htmlFor="responsibility">
									Responsibility
								</label>
								<AsyncSelect
									defaultOptions={responsibility.items}
									placeholder=""
									id="responsibility"
									name="responsibility"
									value={isToDropFocused ? '' : fieldsToCreateNewPMItems.responsibility}
									loadOptions={searchFieldOptimized}
									menuPortalTarget={document.body}
									onMenuScrollToBottom={fetchConcatsOnLoadMore}
									onInputChange={val => {
										if (!val) searchFieldOptimized();
									}}
									onChange={(data, event) => {
										handleFieldChange(event.name, data);
										setIsToDropFocused(false);
									}}
									isSearchable={true}
									required
									components={{ DropdownIndicator }}
									label="Responsibility"
									onBlur={() => setIsToDropFocused(false)}
									onMenuOpen={() => {
										searchFieldOptimized();
										setIsToDropFocused(true);
									}}
									styles={
										isSubmitted && !fieldsToCreateNewPMItems.responsibility
											? invalidCustomStyles(currentOfficeTheme)
											: customStyles(currentOfficeTheme)
									}
								/>
							</FormControl>
						</Stack.Item>

						<Stack.Item>
							<FormControl sx={{ width: '100%' }} size="small">
								<label aria-label="Description" style={headerTextStyle}>
									Description
								</label>
								<textarea
									ref={textareaRefCallback}
									name="description"
									aria-label="Enter a Description"
									className={`create-actions-textarea ${isSubmitted && !fieldsToCreateNewPMItems.HTMLDescription ? 'is-invalid' : ''
										}`}
									value={fieldsToCreateNewPMItems?.HTMLDescription || ''}
									onChange={(e) => {
										handleFieldChange('HTMLDescription', e.target.value);
										handleFieldChange('description', e.target.value);
										autoResizeTextarea(e);
									}}
									rows={6}
									style={{
										'--ca-bg': currentOfficeTheme.bodyBackgroundColor,
										'--ca-fg': currentOfficeTheme.bodyForegroundColor,
										'--ca-border': COLORS.BORDER_COLOR,
										'--ca-invalid-border': COLORS.RED,
										'--ca-font-family': baseFontFamilyStyle,
									}}
									maxlength="4000"
								/>
							</FormControl>
						</Stack.Item>
					</>
				);
			case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_COMMUNICATION:
				return (
					<>
						<Stack.Item>
							<FormControl sx={{ width: '100%' }} size="small">
								<TextField
									label="Subject"
									className={text_theme}
									placeholder="Enter a Subject"
									autoAdjustHeight
									name="title"
									autoComplete="off"
									maxLength={200}
									styles={textInputStyles}
									value={fieldsToCreateNewPMItems.title}
									aria-required
									required={true}
									aria-errormessage="Subject is a required field"
									invalid={isSubmitted && !fieldsToCreateNewPMItems.subject}
									onChange={(event, option, index) => {
										handleFieldChange(event?.target?.name, option.substring(0, 200));
									}}
								/>
							</FormControl>
						</Stack.Item>

						<Stack.Item>
							<FormControl sx={{ width: '100%' }} size="small">
								<Stack tokens={stackTokens}>
									<Dropdown
										placeholder="Please Select"
										label="From"
										options={responsibility}
										styles={dropdownStyles}
										required={true}
										onChange={(event, option, index) => {
											setFieldsToCreateNewPMItems(prev => {
												return {
													...prev,
													From: option.value,
												};
											});
										}}
									/>
								</Stack>
							</FormControl>
						</Stack.Item>

						<Stack.Item>
							<FormControl sx={{ width: '100%' }} size="small">
								<Stack tokens={stackTokens}>
									<Dropdown
										placeholder="Please Select"
										label="To"
										options={responsibility}
										styles={dropdownStyles}
										required={true}
										onChange={(event, option, index) => {
											setFieldsToCreateNewPMItems(prev => {
												return {
													...prev,
													responsibility: option.value,
												};
											});
										}}
									/>
								</Stack>
							</FormControl>
						</Stack.Item>

						<Stack.Item>
							<FormControl sx={{ width: '100%' }} size="small">
								<TextField
									label="Message"
									className={text_theme}
									placeholder="Enter a Message"
									name="description"
									autoComplete="off"
									styles={textInputStyles}
									aria-required
									multiline
									maxLength={4000}
									rows={5}
									required={true}
									value={fieldsToCreateNewPMItems.description}
									aria-errormessage="Description is a required field"
									invalid={isSubmitted && !fieldsToCreateNewPMItems.description}
									onChange={(event, option, index) => {
										handleFieldChange(event?.target?.name, option.substring(0, 4000));
									}}
								/>
							</FormControl>
						</Stack.Item>
					</>
				);

			default:
				return null;
		}
	};

	let formUI = showFormUI(selectedNodeType);

	return (
		<>
			<HeaderUI />
			<Stack className="createNewAction" styles={parentStackStyles} tokens={stackTokens}>
				<Stack
					style={{
						background:
							currentOfficeTheme.themeId === THEME_ID.BLACK ||
								currentOfficeTheme.themeId === THEME_ID.DARK_GREY
								? currentOfficeTheme.bodyBackgroundColor
								: '#faf9f8',
						padding: '0.5rem',
					}}
				>
					{formUI}
					<AttachmentContainer attachedData={attachedData} />
				</Stack>
			</Stack>
		</>
	);
};

export default CreateActions;
